import { z } from "zod";
/**
 * Which Crux emails one person gets about one brand report.
 *
 * Per person: the owner wanting alerts says nothing about whether a colleague
 * does. Every kind starts on.
 */
export const emailKindSchema = z.enum([
    "weekly",
    "monthly",
    "brand_alerts",
    "rival_alerts",
    "discovered",
]);
export const emailPreferencesSchema = z.object({
    reportId: z.string(),
    kinds: z.array(z.object({ kind: emailKindSchema, enabled: z.boolean() })),
    /**
     * Whether this deployment sends brand emails to this person at all
     * (BRAND_EMAILS_ALLOW). A switch that is on for an address the server will
     * never mail would promise something nothing does, so the screen says so.
     */
    delivered: z.boolean(),
});
export const setEmailPreferenceSchema = z.object({
    kind: emailKindSchema,
    enabled: z.boolean(),
});
/**
 * One email Crux sent one person, or tried to: what it was, its subject, and
 * whether it went. The transport's error stays in the log (§5): a customer
 * learns that it did not go, not the mail server's words.
 */
export const sentEmailSchema = z.object({
    kind: z.enum([
        "weekly",
        "monthly",
        "alert_drop",
        "alert_rise",
        "rival_surge",
        "discovered",
    ]),
    subject: z.string(),
    status: z.enum(["sent", "failed", "pending"]),
    /** When it went, or when it was first tried. */
    at: z.string(),
});
/**
 * The emails the signed-in person was sent about one report, newest first:
 * its alerts, and the weekly and monthly reports, which cover every report
 * they follow. Theirs only — an inbox is not the workspace's to read.
 */
export const emailHistorySchema = z.object({
    reportId: z.string(),
    emails: z.array(sentEmailSchema),
    /** How many the list holds at most, so the screen can say so. */
    limit: z.number().int().min(1),
});
//# sourceMappingURL=emails.js.map